// extracted by mini-css-extract-plugin
module.exports = {"Package":"PackagesCard-module--Package--1hnxs","Package__price":"PackagesCard-module--Package__price--2GkMj","para":"PackagesCard-module--para--dY5NC"};